import { computed } from 'vue';

import { isProduction } from '../utils/env';
import type { PluginOptions } from './type';
import { useSettingsStore } from '../stores';

/** 公共神策配置 */
const sensorsConfig = computed(() => {
  return {
    platform_type: 'Web',
    platform_name: 'OWF_PC',
    system_code: 'ESG-FRDSS-CORE',
    product_name: 'PC_TEMPLATE',
  };
});

/** 子应用配置 */
const subConfig = computed(() => {
  const settingsStore = useSettingsStore();
  return settingsStore.settings;
});

const options: PluginOptions = {
  async onVuePluginRegister({}) {
    const { default: sensors } = await import('sa-sdk-javascript');

    const trackCommon = async (event: string, obj?: any) => {
      const server_url = `https://ubs.sf-express.com/sa?project=${isProduction ? 'digital' : 'digitalgray'}`;
      const targetPara = (window as any).sensorsDataAnalytic201505?.para;
      let saveUrl = server_url;
      if (targetPara) {
        saveUrl = targetPara.server_url;
        targetPara.server_url = server_url;
      } else {
        sensors?.init({
          server_url,
          is_track_single_page: false,
          use_client_time: false,
          send_type: 'beacon',
          show_log: false,
          heatmap: {
            // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
            clickmap: 'not_collect',
            // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
            scroll_notice_map: 'not_collect',
            // 目前若开启全埋点支持任意层级 div 标签功能会发送1个404错误请求
            get_vtrack_config: false,
          },
        });
      }
      const sub_system_code = subConfig.value?.sensorsConfig?.system_code || subConfig.value?.system?.systemCode;
      const domain = window.location.hostname;
      const is_multi_sub = subConfig.value?.subApps && subConfig.value?.subApps.length > 1;
      const sub_info =
        subConfig.value?.subApps?.map((item) => {
          const resItem: Record<string, any> = {};
          for (const key in item) {
            const tmpKey = key
              .replace(/([A-Z])/g, '_$1') // 在大写字母前添加下划线
              .toLowerCase() // 全转小写
              .replace(/^_/, ''); // 移除开头多余的下划线
            resItem[tmpKey] = item[key as keyof typeof item];
          }
          return resItem;
        }) || [];
      let jsonStr = '';
      try {
        jsonStr = JSON.stringify(sub_info);
      } catch (error) {
        console.error('序列化子应用信息失败');
      }
      sensors?.track(event, {
        ...sensorsConfig.value,
        sub_system_code,
        domain,
        is_multi_sub,
        sub_info: jsonStr,
        ...obj,
      });
      if (!sub_system_code) console.error(`${domain}没有获取到系统编码`);
      if (targetPara) {
        targetPara.server_url = saveUrl;
      }
    };
    const {
      version,
      sdesignElementPlus,
      sdesignIconsVue,
      sdesignTheme,
      sentryVue,
      sfvineMain,
      sfvineMainQiankun,
      vue,
    } = await import('../autoReplaceEjsVar');
    await trackCommon('frameworkInit', {
      version,
      sdesignElementPlus,
      sdesignIconsVue,
      sdesignTheme,
      sentryVue,
      sfvineMain,
      sfvineMainQiankun,
      vue,
    });
    if ((window as any).sensorsDataAnalytic201505) {
      (window as any).sensorsDataAnalytic201505['trackCommon'] = trackCommon;
    }
  },
};

export default options;
